;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.quantityMultiplier = function(element, options) {
    this.$el = $(element);
    this.options = options;
    this._currentSupplierId = null;
    this._currentSku = null;
    this._currentQuantityMultiplier = null;
    this._currentExternalId = null;
    this._currentContentGroupId = null;
};

bq.quantityMultiplier.DEFAULTS = {
    updateUnitsPerSkuUrl: '',
    labels: {
        notSet: 'Not set',
        pleaseEnterValue: 'Please enter a units per sku value.',
        invalidNumber: 'Please enter a valid number greater than 0.',
        missingSupplierId: 'Error: Missing supplier_id or sku. Cannot update units per sku.',
        saving: 'Saving...',
        savingUnitsPerSku: 'Saving units per sku...',
        saveSuccess: 'Units per sku saved successfully!',
        saveFailed: 'Failed to save units per sku',
        save: 'Save'
    }
};

bq.quantityMultiplier.prototype = {
    init: function() {
        this._bindEvents();
        this._initFromContext();
    },

    _initFromContext: function() {
        var labels = bq.messages.recommendations;
        var $contentGroupDropdown = $('#bq-recs-content-group');
        this._currentContentGroupId = $contentGroupDropdown.length ? $contentGroupDropdown.val() : null;

        if (window.bqOpenCaseSizingFor) {
            this._currentSupplierId = window.bqOpenCaseSizingFor.supplier_id;
            this._currentSku = window.bqOpenCaseSizingFor.sku;
            this._currentQuantityMultiplier = window.bqOpenCaseSizingFor.case_sizing;
            this._currentExternalId = window.bqOpenCaseSizingFor.external_id || null;

            if (window.bqOpenCaseSizingFor.image) {
                var imageSrc = String(window.bqOpenCaseSizingFor.image).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
                this.$el.find('#bqQuantityMultiplier-product-image').html(
                    '<img src="' + imageSrc + '" alt="" class="rec-img--lg" />'
                );
            } else {
                this.$el.find('#bqQuantityMultiplier-product-image').html(
                    '<div class="rec-img-placeholder--lg">No Image</div>'
                );
            }

            this.$el.find('#bqQuantityMultiplier-product-name').text(window.bqOpenCaseSizingFor.name || '-');
            this.$el.find('#bqQuantityMultiplier-product-sku').text(window.bqOpenCaseSizingFor.sku || '-');
            this.$el.find('#bqQuantityMultiplier-product-price').html(window.bqOpenCaseSizingFor.price || '-');

            var qtyMultiplier = this._currentQuantityMultiplier;
            if (qtyMultiplier !== null && qtyMultiplier !== undefined && qtyMultiplier !== '') {
                var formattedValue = parseFloat(qtyMultiplier);
                if (!isNaN(formattedValue)) {
                    this.$el.find('#bqQuantityMultiplier-current-display').text(
                        formattedValue % 1 === 0 ? formattedValue.toString() : formattedValue.toFixed(2).replace(/\.?0+$/, '')
                    );
                } else {
                    this.$el.find('#bqQuantityMultiplier-current-display').text(labels.notSet);
                }
            } else {
                this.$el.find('#bqQuantityMultiplier-current-display').text(labels.notSet);
            }
        } else {
            var supplierId = this.$el.attr('data-supplier-id');
            var sku = this.$el.attr('data-sku');
            if (supplierId && sku) {
                this._currentSupplierId = supplierId;
                this._currentSku = sku;
            }
        }
    },

    _bindEvents: function() {
        var self = this;

        $(document).off('click.quantityMultiplier', '.quantity-multiplier-modal-cancel')
            .on('click.quantityMultiplier', '.quantity-multiplier-modal-cancel', function(e) {
                e.preventDefault();
                $(this).closest('.modal').modal('hide');
            });

        $(document).off('click.quantityMultiplier', '#bqQuantityMultiplier-save-btn')
            .on('click.quantityMultiplier', '#bqQuantityMultiplier-save-btn', function() {
                self._handleSave();
            });

        $(document).off('hidden.bs.modal.quantityMultiplier')
            .on('hidden.bs.modal.quantityMultiplier', function(e) {
                if ($(e.target).find('.quantity-multiplier-form-content').length) {
                    self._reset();
                }
            });

        $(document).off('quantityMultiplierFormInserted.quantityMultiplier')
            .on('quantityMultiplierFormInserted.quantityMultiplier', function() {
                setTimeout(function() { self._initFromContext(); }, 50);
            });
    },

    _handleSave: function() {
        var self = this;
        var labels = bq.messages.recommendations;
        var $saveBtn = this.$el.find('#bqQuantityMultiplier-save-btn');
        var $status = this.$el.find('#bqQuantityMultiplier-status');
        var $newValueInput = this.$el.find('#bqQuantityMultiplier-new-value');

        var newValue = $newValueInput.val().trim();
        if (!newValue) {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.pleaseEnterValue).show();
            return;
        }

        var numericValue = parseFloat(newValue);
        if (isNaN(numericValue) || numericValue <= 0) {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.invalidNumber).show();
            return;
        }

        if (!this._currentSupplierId || !this._currentSku) {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.missingSupplierIdSku).show();
            return;
        }

        $saveBtn.prop('disabled', true).text(labels.saving);
        $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-info')
            .text(labels.savingUnitsPerSku).show();

        var requestData = {
            supplier_id: String(this._currentSupplierId),
            sku: String(this._currentSku),
            units_per_sku: numericValue
        };

        if (this._currentContentGroupId && this._currentContentGroupId !== '' &&
            this._currentContentGroupId !== null && this._currentContentGroupId !== undefined) {
            requestData.content_group_id = this._currentContentGroupId;
        }

        $.ajax({
            url: this.options.updateUnitsPerSkuUrl,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(requestData)
        }).done(function(data) {
            if (data && data.success) {
                $status.removeClass('alert-info alert-danger alert-warning').addClass('alert-success')
                    .text(labels.saveUnitsPerSkuSuccess);
                setTimeout(function() {
                    self.$el.closest('.modal').modal('hide');
                    $(document).trigger('bqQuantityMultiplierSaved', {
                        supplier_id: self._currentSupplierId,
                        sku: self._currentSku,
                        quantity: numericValue
                    });
                }, 1000);
            } else {
                var errorMsg = (data && data.error) ? data.error : labels.saveUnitsPerSkuFailed;
                $status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger').text(errorMsg);
                $saveBtn.prop('disabled', false).text(labels.save);
            }
        }).fail(function(xhr) {
            var errorMsg = labels.saveUnitsPerSkuFailed;
            if (xhr.responseJSON && xhr.responseJSON.error) {
                errorMsg += ': ' + xhr.responseJSON.error;
            }
            $status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger').text(errorMsg);
            $saveBtn.prop('disabled', false).text(labels.save);
        });
    },

    _reset: function() {
        this.$el.find('#bqQuantityMultiplier-new-value').val('');
        this.$el.find('#bqQuantityMultiplier-status').hide();
        this.$el.find('#bqQuantityMultiplier-save-btn').prop('disabled', false)
            .text(bq.messages.recommendations.save);
        window.bqOpenCaseSizingFor = null;
        this._currentSupplierId = null;
        this._currentSku = null;
        this._currentQuantityMultiplier = null;
        this._currentExternalId = null;
        this._currentContentGroupId = null;
    }
};

var oldQuantityMultiplier = $.fn.quantityMultiplier;
$.fn.quantityMultiplier = function(option) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('bq.quantityMultiplier');
        var options = $.extend(true, {}, bq.quantityMultiplier.DEFAULTS, $this.data(), typeof option === 'object' && option);
        if (!data) { $this.data('bq.quantityMultiplier', (data = new bq.quantityMultiplier(this, options))); }
        data.init();
    });
};
$.fn.quantityMultiplier.Constructor = bq.quantityMultiplier;
$.fn.quantityMultiplier.noConflict = function() { $.fn.quantityMultiplier = oldQuantityMultiplier; return this; };

bq.quantityMultiplierInit = function() {
    $('[data-bq="quantity-multiplier"]:not([data-initialized])').each(function() {
        $(this).quantityMultiplier($(this).data());
    });
};
bq.init.push(bq.quantityMultiplierInit);
bq.quantityMultiplierInit();

});}( window, document, bq));
